import React from 'react';
import IconButton from 'components/common/IconButton';

/**
 * @component UserTableActions
 * @description
 * Componente de acciones de tabla para usuarios. Renderiza un botón con ícono que permite ejecutar una acción (como abrir un modal para crear un nuevo usuario).
 *
 * Este botón está pensado para mostrarse en la cabecera de una tabla y abrir un formulario o modal de registro.
 *
 * @param {Object} props - Props del componente
 * @param {Function} props.handleOpen - Función que se ejecuta al hacer clic en el botón. Generalmente abre un modal.
 *
 * @returns {JSX.Element} Botón de acción para crear un nuevo usuario.
 *
 * @example
 * <UserTableActions handleOpen={() => setIsModalOpen(true)} />
 */

const UserTableActions = ({ handleOpen }) => {
    return (
        <div id="orders-actions">
            <IconButton
                variant="falcon-default"
                size="sm"
                icon="plus"
                transform="shrink-3"
                iconAlign="middle"
                onClick={handleOpen}>
                <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
                    Nuevo
                </span>
            </IconButton>
        </div>
    );
};

export default UserTableActions;